import React from 'react'
import { Link } from 'react-router-dom'
import Breadcumb from '../../Breadcumb/Main'
//  import ServiceSidebar from '../../Services/ServiceSidebar/Main'
import itc from "../../../assets/images/industries/construction.jpg";
import IndustriesSideBar from '../IndustriesSideBar/Main';
import { useTranslation } from 'react-i18next';


const Construction = () => {
    const { t } = useTranslation();
    // const [clicked, setClicked] = useState(0);
    // const faqs = [
    // 	{
    // 		question: "Nulla eu nisi pellentesque, ultrices lorem eget, mattis dolo",
    // 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
    // 	},
    // 	{
    // 		question: "Praesent nec ante sed libero tempus rutrum",
    // 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
    // 	},
    // 	{
    // 		question: "Integer et mi in eros commodo bibendum",
    // 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
    // 	},
    // 	{
    // 		question: "Proin commodo turpis eu leo tempus varius",
    // 		answer: "There are many variations of passages the majority have suffered alteration in some fo injected humour, or randomised words believable. Phasellus a rhoncus erat. Vivamus vel eros vitae estaliquet pellentesque vitae."
    // 	}
    // ]
    return (
        <>
            <Breadcumb Title={t("industries.construction.construction_it")} Breadcumb={t("breadcrumb.industries")} />
            <section className="section-padding--bottom section-padding--top service-details--page">
                <div className="container">
                    <div className="row ">
                        <div className="col-lg-8">
                            <div className="service-details__image">
                                <img src={itc} alt="" />
                            </div>
                            <h3 className="service-details__title">{t("industries.construction.construction_it")}</h3>
                            <div className="service-details__content">
                                <p>
                                    <b>{t("industries.construction.innovative_app")}</b>
                                </p>
                                <h4>
                                    {t("industries.construction.it_sol")}
                                </h4>
                                <p>
                                    {t("industries.construction.Code Craft_offer")}
                                </p>
                                <p>
                                    {t("industries.construction.robust")}
                                </p>
                                <p>
                                    {t("industries.construction.biggest")}
                                </p>
                                <h4>
                                    {t("industries.construction.our_service")}
                                </h4>
                                <p>
                                    <b>{t("industries.construction.tech_consult")}</b>
                                </p>
                                <p>
                                    {t("industries.construction.detailed")}
                                </p>
                                <p>
                                    <b>{t("industries.construction.mobility")}</b>
                                </p>
                                <p>
                                    {t("industries.construction.boosting")}
                                </p>
                                <p>
                                    <b>{t("industries.construction.cloud")}</b>
                                </p>
                                <p>
                                    {t("industries.construction.gather")}
                                </p>
                                <p>
                                    <b>{t("industries.construction.analytics")}</b>
                                </p>
                                <p>
                                    {t("industries.construction.track")}
                                </p>
                                <p>
                                    {t("industries.construction.it_support")}
                                </p>
                                <p>
                                    {t("industries.construction.drawing")}
                                </p>
                                <h4>
                                    {t("industries.construction.wearable")}
                                </h4>
                                <p>
                                    <b>{t("industries.construction.field_productivity")}</b>
                                </p>
                                <p>
                                    {t("industries.construction.tools")}
                                </p>
                                <p>
                                    <b>{t("industries.construction.safety")}</b>
                                </p>
                                <p>
                                    {t("industries.construction.reporting")}
                                </p>
                                <p>
                                    <b>{t("industries.construction.design_managament")}</b>
                                </p>
                                <p>
                                    {t("industries.construction.better")}
                                </p>
                                <p>
                                    <b>{t("industries.construction.contract")}</b>
                                </p> 
                                <p>
                                    {t("industries.construction.specially")}
                                </p>
                                <p>
                                    <b>{t("industries.construction.performance_management")}</b>
                                </p>
                                <p>
                                    {t("industries.construction.help_track")}
                                </p>
                                <p>
                                    <b>{t("industries.construction.document")}</b>
                                </p>
                                <p>
                                    {t("industries.construction.quick")}
                                </p>
                            </div>
                            <div className="row gutter-y-30 service-details__box-wrapper">
                                <div className="col-md-6 col-sm-12">
                                    <div className="service-details__box">
                                        <i className="service-details__box__icon icon-consulting"></i>
                                        <div className="service-details__box__content">
                                            <h3 className="service-details__box__title">
                                                <Link to="#">{t("industries.construction.it_consultant")}</Link>
                                            </h3>
                                            <p className="service-details__box__text">
                                                {t("industries.construction.questions")}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <div className="service-details__box">
                                        <i className="service-details__box__icon icon-chip"></i>
                                        <div className="service-details__box__content">
                                            <h3 className="service-details__box__title">
                                                <Link to="#">{t("industries.construction.it_specialist")}</Link>
                                            </h3>
                                            <p className="service-details__box__text">
                                                {t("industries.construction.reach")}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="row gutter-y-30">
                <div className="col-md-6 col-sm-12">
                  <img
                    src="assets/images/services/service-d-2.jpg"
                    className="service-details__sub-image"
                    alt=""
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="service-details__caption">
                    <h3 className="service-details__caption__title">
                      Our Benefits
                    </h3>
                    <p className="service-details__caption__text">
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum.
                    </p>
                    <ul className="service-details__caption__list">
                      <li>
                        <i className="fa fa-check-circle"></i>
                        Praesent efficitur quam sit amet
                      </li>
                      <li>
                        <i className="fa fa-check-circle"></i>
                        Nunc cursus dolor id purus euismod
                      </li>
                      <li>
                        <i className="fa fa-check-circle"></i>
                        Quisque tincidunt eros ac plac <ServiceSidebar />e viverra
                      </li>
                    </ul>
                  </div>
                </div>
              </div> */}

                    {/* <div className="row">
                <div className="col-md-12">
                  <div
                    className="accrodion-grp service-details__accrodion"
                    data-grp-name="service-details__accrodion-1"
                  >
                    {faqs.map((item, index) => (
                      <div
                        className={`accrodion wow fadeInUp ${
                          index === clicked && "active"
                        }`}
                        key={index}
                        data-wow-delay="0ms"
                      >
                        <div className="accrodion-title">
                          <h4 onClick={() => setClicked(index)}>
                            {item.question}
                            <span className="accrodion-icon"></span>
                          </h4>
                        </div>
                        {index === clicked && (
                          <div className="accrodion-content">
                            <div className="inner">
                              <p>{item.answer}</p>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div> */}
                        </div>
                        <div className="col-lg-4 sidebar-column">
                            {/* <ServiceSidebar /> */}
                        <IndustriesSideBar/>
                            
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Construction